import { Model as t } from "../../../model.js";
class r extends t {
  constructor(s) {
    super(), this.ga = s.ga, this.gtm = s.gtm, this.status = s.status;
  }
}
export {
  r as GoogleAnalyticsModel
};
//# sourceMappingURL=google.model.js.map
